import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import Axios from 'axios'
import vSelect from "vue-select";
import wysiwyg from "vue-wysiwyg";

import './assets/css/app.css';
import './assets/css/loader.css';
import './assets/css/bootstrap-float-label.css';
import './assets/css/modal.css';
import "vue-wysiwyg/dist/vueWysiwyg.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'ionicons-npm/css/ionicons.min.css'
import "flagkit-web/styles/flagkit.css"
import "pe7-icon/dist/dist/pe-icon-7-stroke.min.css"


require('@/store/subscribe.js');

if(window.location.hostname == 'distribuidoragarcia.com.ar'){
  Axios.defaults.baseURL = "https://geonapi.distribuidoragarcia.com.ar/api";
}else if(window.location.hostname == 'distribuidora.pampadev.com.ar'){
  Axios.defaults.baseURL = "https://apidistribuidora.pampadev.com.ar/api";
}else if(window.location.hostname == 'distribuidoralacapital.com.ar'){
  Axios.defaults.baseURL = "https://api.distribuidoralacapital.com.ar/api";
}else{
  Axios.defaults.baseURL = "http://localhost:8000/api";
}

Vue.config.productionTip = false

//SI ACTUALIZA LA PAGINA CHECKEA SI TIENE EL TOKEN EN LOCALSTORAGE
store.commit('auth/SET_CHECK', false);
store.dispatch('auth/attempt', localStorage.getItem('token'));

router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && !store.state.auth.user && !store.state.auth.token) {
    //SI NO TIENE INICIADA LA SESION REDIRECCIONA AL LOGIN
    next({ name: 'Login' })
    window.location.reload();
  }else if(to.name === 'Login' && store.state.auth.user && store.state.auth.token){
    //SI VA AL LOGIN CON LA SESION INICIADA REDIRECCIONA A HOME
    next({name:'Home'});
  }
  else next()
})


const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
    moment
})

Vue.use(Vuelidate);

Vue.use(wysiwyg, {
  hideModules: {
    "italic": true,
    "underline": true,
    "removeFormat": true,
    "image": true,
    "justifyLeft": true,
    "justifyCenter": true,
    "justifyRight": true,
    "headings": true,
    "link": true,
    "code": true,
    "orderedList": true,
    "unorderedList": true,
    "table": true,
    "separator": true
  },
});

Vue.filter('cuil', function (value) {
  if (!value) return ''
  value = value.toString()
  if(value.length == 11){
    let values = value.split("");
    values.splice(2,0,"-");
    values.splice(11,0,"-");
    return values.join("");
  }
  return value;

})
Vue.filter('numFormat', numFormat(numeral));
Vue.component("v-select", vSelect);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

